<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import {contacts} from "@js/company_details.ts";

export default {
    name: "PrivacyPolicyPage",
    components: {MobileTopBar, Breadcrumbs},
    setup(){
        return { contacts };
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container mx-auto">
        <Breadcrumbs class="mb-2"/>

        <h1 class="text-2xl md:text-3xl">Политика конфиденциальности ООО «Дорожные плиты»</h1>
        <p class="text-sm text-gray-600 mt-2">Действует для сайта dorozhnyeplity.ru</p>
        <hr class="mt-5 mb-5"/>

        <!-- 1. Общие положения -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">1. Общие положения</h2>
            <p class="text-sm mb-2">
                Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок обработки и защиты
                персональных данных пользователей сайта <strong>dorozhnyeplity.ru</strong> (далее — «Сайт»),
                администратором и оператором персональных данных которого является <strong>ООО «Дорожные плиты»</strong>
                (далее — «Оператор»).
            </p>
            <p class="text-sm mb-2">
                Оператор осуществляет обработку персональных данных в соответствии с законодательством Российской
                Федерации, включая Федеральный закон № <strong>152‑ФЗ «О персональных данных»</strong> и иные
                применимые нормативные акты.
            </p>
        </div>

        <!-- 2. Термины и состав персональных данных -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">2. Состав персональных данных и термины</h2>
            <p class="text-sm mb-2">
                Под персональными данными понимается любая информация, относящаяся к прямо или косвенно определённому
                или определяемому физическому лицу (пользователю Сайта). К таким данным могут относиться: имя,
                телефон, электронная почта, адрес доставки, сведения о заказах и платежах, а также иные сведения,
                которые пользователь добровольно предоставляет через формы Сайта или при общении с Оператором.
            </p>
        </div>

        <!-- 3. Цели обработки -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">3. Цели обработки персональных данных</h2>
            <ul class="list-disc pl-6 text-sm space-y-2">
                <li>приём и обработка заявок/заказов на ЖБИ и бетонные смеси, обратная связь;</li>
                <li>заключение и исполнение договоров поставки, выставление счетов, оформление закрывающих документов;</li>
                <li>организация доставки и разгрузки, информирование о статусах заказов;</li>
                <li>обработка обращений и претензий, улучшение качества сервиса;</li>
                <li>направление информационных сообщений при согласии пользователя (e‑mail/SMS/мессенджеры);</li>
                <li>ведение бухгалтерского и налогового учёта в рамках требований законодательства РФ;</li>
                <li>обеспечение безопасности и функционирования Сайта, предотвращение мошенничества.</li>
            </ul>
        </div>

        <!-- 4. Правовые основания -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">4. Правовые основания обработки</h2>
            <p class="text-sm mb-2">
                Обработка персональных данных осуществляется на основании: (а) согласия пользователя; (б) необходимости
                исполнения договора или заключения договора по инициативе пользователя; (в) исполнения обязанностей,
                возложенных на Оператора законодательством РФ; (г) законных интересов Оператора при условии соблюдения
                прав и свобод пользователя.
            </p>
        </div>

        <!-- 5. Cookies и технические данные -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">5. Файлы cookies и технические данные</h2>
            <p class="text-sm mb-2">
                Сайт использует cookies и аналогичные технологии для обеспечения работоспособности, персонализации и
                аналитики. Также автоматически фиксируются технические данные: IP‑адрес, дата и время посещения,
                параметры браузера и ОС, URL‑адреса посещённых страниц. Эти данные применяются для корректного
                отображения контента и повышения качества сервиса.
            </p>
            <p class="text-sm mb-2">
                Пользователь может ограничить или отключить использование cookies в настройках браузера. В этом случае
                часть функций Сайта может работать некорректно.
            </p>
        </div>

        <!-- 6. Сторонние сервисы аналитики и рекламы -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">6. Сторонние сервисы аналитики и рекламы</h2>
            <p class="text-sm mb-2">
                На Сайте могут использоваться сервисы веб‑аналитики и маркетинга (например, Yandex.Metrica, Google
                Analytics, Yandex Ads/Direct и др.), которые обрабатывают обезличенные данные пользователей и cookies по
                правилам соответствующих сервисов. Пользователь может ограничить сбор данных указанными сервисами через
                настройки браузера и плагины‑блокировщики.
            </p>
        </div>

        <!-- 7. Сроки хранения -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">7. Хранение персональных данных</h2>
            <p class="text-sm mb-2">
                Персональные данные хранятся в форме, позволяющей определить субъекта персональных данных, не дольше,
                чем этого требуют цели обработки, либо сроки, установленные законодательством РФ (в том числе по
                бухгалтерским и налоговым документам). По достижении целей обработки данные подлежат удалению или
                обезличиванию, если иное не требуется законом.
            </p>
        </div>

        <!-- 8. Передача третьим лицам -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">8. Передача персональных данных третьим лицам</h2>
            <p class="text-sm mb-2">
                Оператор может передавать персональные данные курьерским и транспортным компаниям, платёжным
                провайдерам, банкам и иным подрядчикам строго в объёме, необходимом для исполнения обязательств перед
                пользователем. Передача третьим лицам для целей, не связанных с исполнением договора или законом,
                осуществляется только при наличии согласия пользователя.
            </p>
        </div>

        <!-- 9. Права пользователя -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">9. Права пользователя</h2>
            <p class="text-sm mb-2">
                Пользователь имеет право на получение сведений о обработке его персональных данных, требование их
                уточнения, блокирования или уничтожения при наличии оснований, отзыв согласия на обработку, а также
                обжалование действий Оператора в уполномоченный орган по защите прав субъектов персональных данных или
                в суд.
            </p>
            <p class="text-sm mb-2">
                Для реализации прав направьте запрос на адрес: <strong>{{ contacts.info_mail }}</strong>.
            </p>
        </div>

        <!-- 10. Трансграничная передача -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">10. Трансграничная передача данных</h2>
            <p class="text-sm mb-2">
                При необходимости использования зарубежных сервисов (хостинг, аналитика и пр.) Оператор обеспечивает
                соблюдение требований законодательства РФ к трансграничной передаче персональных данных, включая
                передачу в страны, обеспечивающие адекватную защиту прав субъектов персональных данных.
            </p>
        </div>

        <!-- 11. Дети -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">11. Данные несовершеннолетних</h2>
            <p class="text-sm mb-2">
                Сайт и услуги Оператора не предназначены для самостоятельного использования несовершеннолетними лицами.
                Персональные данные несовершеннолетних обрабатываются только с согласия законных представителей.
                Если вам стало известно, что ребёнок предоставил нам данные без согласия, свяжитесь с нами по адресу
                <strong>{{ contacts.info_mail }}</strong> для удаления такой информации.
            </p>
        </div>

        <!-- 12. Ссылки -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">12. Ссылки на сторонние сайты</h2>
            <p class="text-sm mb-2">
                На Сайте могут размещаться ссылки на сторонние ресурсы. Оператор не несёт ответственность за политику
                конфиденциальности и содержание сторонних сайтов и рекомендует ознакомиться с их условиями
                самостоятельно.
            </p>
        </div>

        <!-- 13. Изменения политики -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">13. Изменения и актуальная редакция Политики</h2>
            <p class="text-sm mb-2">
                Оператор вправе обновлять настоящую Политику. Актуальная редакция доступна на странице Сайта. При
                внесении существенных изменений Оператор может направлять уведомления пользователям, если это технически
                возможно и если у Оператора есть контактные данные пользователя.
            </p>
        </div>

        <!-- 14. Контакты оператора -->
        <div class="mb-10">
            <h2 class="text-xl md:text-2xl mb-5">14. Контакты оператора</h2>
            <p class="text-sm mb-2">
                Оператор: <strong>ООО «Дорожные плиты»</strong><br/>
                Сайт: <strong>dorozhnyeplity.ru</strong><br/>
                Электронная почта для обращений по персональным данным: <strong>{{ contacts.info_mail }}</strong>
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
</style>
